import { PrimaryButton } from "@fluentui/react";
import { Edit12Regular, Heart16Regular, PageFit20Regular } from "@fluentui/react-icons";
import { useEffect } from "react";
import { logEvent } from "../../helper/AppInsightsHelper";

const email = "Security360Core@microsoft.com";
const security360TeamsChannelLink = "https://teams.microsoft.com/l/channel/19%3A8b7b5e2a73504173981affdd3afbe811%40thread.tacv2/Security%20360?groupId=220a9a3b-eacf-4cb1-927b-7c8bbd4562ca&tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47&ctx=chat&message=Report%20a%20Problem%20or%20Suggestion";
export const FeedbackBody = () => {

  useEffect(() => {
    logEvent("Feedback Blade", "Feedback Blade", "FeedbackBody");
  }, []);

  return (
    <>
      <div style={{ marginRight: 5, background: "#FFF" }}>
        <br />
        <div style={{ paddingLeft: "5px", marginLeft: "-20px" }}>
          <label style={{ paddingBottom: "10px", fontWeight: 600 }}>
            Classify your feedback <label style={{ color: "#d50000" }}>*</label>
          </label>
          <br />
          <br />
            <>
              <PrimaryButton
                style={{
                  marginBottom: "12px;",
                  height: "45px",
                  width: "300px",
                  marginTop: "7px"
                }}
                onClick={() => {
                  window.location.href = `mailto:${email}`;
                }}
              >
                <Heart16Regular
                  style={{
                    width: "15px",
                    height: "15px",
                    paddingTop: "2px"
                  }}
                />
                &nbsp;Give a compliment
              </PrimaryButton>
              <br />
              <br />
            </>
            <>
              <PrimaryButton
                style={{
                  marginBottom: "12px;",
                  height: "45px",
                  width: "300px"
                }}
                text=""
                onClick={() => {
                  window.open(security360TeamsChannelLink);
                }}
              >
                <Edit12Regular
                  style={{
                    width: "15px",
                    height: "15px",
                    paddingTop: "2px"
                  }}
                />
                &nbsp;Report a problem
              </PrimaryButton>
              <br />
              <br />
            </>
            <>
              {" "}
              <PrimaryButton
                onClick={() => {
                  window.open(security360TeamsChannelLink);
                }}
                style={{
                  marginTop: "12px;",
                  height: "45px",
                  width: "300px"
                }}
              >
                {" "}
                <PageFit20Regular
                  style={{
                    width: "15px",
                    height: "15px",
                    paddingTop: "2px"
                  }}
                />
                &nbsp;Make a suggestion
              </PrimaryButton>
              <br />
              <br />
            </>
          <label
            style={{
              fontSize: "10px",
              fontWeight: 400,
              display: "block",
              color: "rgb(96, 94, 92)"
            }}
          >
            Your feedback will help enhance Microsoft products and services.
            <a
              target="_blank"
              href="https://privacy.microsoft.com/en-us/privacystatement"
              style={{
                color: "hsl(206, 100%, 42%)",
                cursor: "pointer"
              }}
              rel="noreferrer"
            >
              Privacy statement.
            </a>
          </label>
          <br />
        </div>
      </div>
    </>
  );
};

export default FeedbackBody;
